(function () {
  var MOBILE_MQ = window.matchMedia("(max-width: 768px)");
  var AUTOPLAY_MS = 6500;

  function mod(n, m) {
    return ((n % m) + m) % m;
  }

  function isMobileLayout() {
    return MOBILE_MQ.matches;
  }

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function getSlideLabel(tpl) {
    var info = tpl.content.querySelector("[data-obs-info]");
    if (!info) return "Projet";
    var num = info.querySelector(".obs-loop__obs-num b");
    if (num && num.textContent.trim()) return num.textContent.trim();
    var title = info.querySelector(".obs-loop__title");
    if (title && title.textContent.trim()) return title.textContent.trim();
    return "Projet";
  }

  function getSlideThumbSrc(tpl) {
    var img = tpl.content.querySelector(".obs-loop__thumb-img");
    return img ? img.getAttribute("src") : "";
  }

  function initLoop(root) {
    if (!root || root.dataset.obsLoopInit === "true") return;

    var sourcesWrap = root.querySelector("[data-obs-sources]");
    var bgWrap = root.querySelector("[data-obs-bg-wrap]");
    var bgTrack = root.querySelector("[data-obs-bg-track]");
    var desktopTrack = root.querySelector("[data-obs-desktop-track]");
    var mobileTrack = root.querySelector("[data-obs-mobile-track]");
    var rail = root.querySelector("[data-obs-rail]");
    var carousel = root.querySelector("[data-obs-carousel]");
    var counters = root.querySelectorAll("[data-obs-counter]");
    var prevBtns = root.querySelectorAll("[data-obs-prev]");
    var nextBtns = root.querySelectorAll("[data-obs-next]");

    if (!sourcesWrap || !desktopTrack || !mobileTrack) return;

    var sources = Array.prototype.slice.call(
      sourcesWrap.querySelectorAll("template[data-obs-slide-source]")
    );
    if (!sources.length) return;

    root.dataset.obsLoopInit = "true";

    var slideCount = sources.length;
    var index = 0;
    var totalPadded = root.dataset.obsTotal || String(slideCount).padStart(2, "0");
    var desktopSlides = [];
    var mobileSlides = [];
    var railItems = [];
    var autoplayTimer = null;
    var touchStartX = 0;
    var touchStartY = 0;

    function buildDesktopSlides() {
      desktopTrack.innerHTML = "";
      if (bgTrack) bgTrack.innerHTML = "";

      var slides = [];
      sources.forEach(function (tpl, i) {
        var slide = document.createElement("article");
        slide.className = "obs-loop__desktop-slide";
        slide.dataset.index = String(i);
        slide.hidden = i !== 0;

        var grid = document.createElement("div");
        grid.className = "obs-loop__desktop-slide-grid";

        var infoCol = document.createElement("div");
        infoCol.className = "obs-loop__info-col";
        var infoPanel = tpl.content.querySelector("[data-obs-info]");
        if (infoPanel) {
          var infoClone = infoPanel.cloneNode(true);
          infoClone.classList.add("obs-loop__info-panel");
          infoCol.appendChild(infoClone);
        }

        var thumbCol = document.createElement("div");
        thumbCol.className = "obs-loop__thumb-col";
        var thumbPanel = tpl.content.querySelector("[data-obs-thumb]");
        if (thumbPanel) thumbCol.appendChild(thumbPanel.cloneNode(true));

        grid.appendChild(infoCol);
        grid.appendChild(thumbCol);
        slide.appendChild(grid);
        desktopTrack.appendChild(slide);
        slides.push(slide);

        if (bgTrack) {
          var bgItem = document.createElement("div");
          bgItem.className = "obs-loop__bg-item";
          bgItem.dataset.index = String(i);
          bgItem.style.top = i * 100 + "%";
          var bgPanel = tpl.content.querySelector("[data-obs-bg]");
          if (bgPanel) bgItem.appendChild(bgPanel.cloneNode(true));
          bgTrack.appendChild(bgItem);
        }
      });

      return slides;
    }

    function buildMobileSlides() {
      mobileTrack.innerHTML = "";
      var slides = [];
      sources.forEach(function (tpl, i) {
        var slide = document.createElement("article");
        slide.className = "obs-loop__mobile-slide";
        slide.dataset.index = String(i);
        slide.hidden = i !== 0;

        var media = document.createElement("div");
        media.className = "obs-loop__mobile-media";
        var thumbPanel = tpl.content.querySelector("[data-obs-thumb]");
        if (thumbPanel) media.appendChild(thumbPanel.cloneNode(true));

        var body = document.createElement("div");
        body.className = "obs-loop__mobile-body";
        var infoPanel = tpl.content.querySelector("[data-obs-info]");
        if (infoPanel) body.appendChild(infoPanel.cloneNode(true));

        slide.appendChild(media);
        slide.appendChild(body);
        mobileTrack.appendChild(slide);
        slides.push(slide);
      });
      return slides;
    }

    function buildRail() {
      if (!rail) return [];
      rail.innerHTML = "";
      var items = [];
      sources.forEach(function (tpl, i) {
        var label = getSlideLabel(tpl);
        var thumbSrc = getSlideThumbSrc(tpl);
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "obs-loop__rail-btn" + (i === 0 ? " is-active" : "");
        btn.dataset.index = String(i);
        btn.setAttribute("aria-label", label);
        if (i === 0) btn.setAttribute("aria-current", "true");

        var thumbWrap = document.createElement("span");
        thumbWrap.className = "obs-loop__rail-thumb";
        if (thumbSrc) {
          var img = document.createElement("img");
          img.src = thumbSrc;
          img.alt = "";
          img.width = 72;
          img.height = 72;
          img.loading = "eager";
          img.decoding = "async";
          thumbWrap.appendChild(img);
        } else {
          var ph = document.createElement("span");
          ph.className = "obs-loop__rail-ph mono";
          ph.setAttribute("aria-hidden", "true");
          ph.textContent = "OBS";
          thumbWrap.appendChild(ph);
        }

        var labelEl = document.createElement("span");
        labelEl.className = "obs-loop__rail-label mono";
        labelEl.textContent = label;

        btn.appendChild(thumbWrap);
        btn.appendChild(labelEl);
        btn.addEventListener("click", function () {
          goTo(i);
        });
        rail.appendChild(btn);
        items.push(btn);
      });
      rail.scrollLeft = 0;
      return items;
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (isMobileLayout() || slideCount < 2 || prefersReducedMotion()) return;
      autoplayTimer = setInterval(function () {
        goTo(index + 1, false);
      }, AUTOPLAY_MS);
    }

    function renderCounter() {
      var text = String(index + 1).padStart(2, "0") + " / " + totalPadded;
      Array.prototype.forEach.call(counters, function (counter) {
        counter.textContent = text;
      });
    }

    function renderRail() {
      railItems.forEach(function (btn, i) {
        var isActive = i === index;
        btn.classList.toggle("is-active", isActive);
        if (isActive) btn.setAttribute("aria-current", "true");
        else btn.removeAttribute("aria-current");
      });
      if (rail && rail.scrollWidth <= rail.clientWidth + 1) {
        rail.scrollLeft = 0;
      }
    }

    function renderDesktop() {
      desktopSlides.forEach(function (slide, i) {
        slide.hidden = i !== index;
      });
      if (bgTrack) {
        bgTrack.style.transform = "translate3d(0," + -index * 100 + "%,0)";
      }
    }

    function renderMobile() {
      mobileSlides.forEach(function (slide, i) {
        slide.hidden = i !== index;
      });
    }

    function render() {
      if (isMobileLayout()) renderMobile();
      else renderDesktop();
      renderRail();
      renderCounter();
    }

    function goTo(nextIndex, restartAutoplay) {
      index = mod(nextIndex, slideCount);
      render();
      if (restartAutoplay !== false) {
        stopAutoplay();
        startAutoplay();
      }
    }

    function applyLayoutMode() {
      var mobile = isMobileLayout();
      root.classList.toggle("is-mobile-layout", mobile);

      if (desktopTrack) desktopTrack.hidden = mobile;
      if (mobileTrack) mobileTrack.hidden = !mobile;
      if (rail) rail.hidden = slideCount < 2;
      if (bgWrap) bgWrap.hidden = mobile;

      stopAutoplay();

      railItems = buildRail();

      if (mobile) {
        if (bgTrack) bgTrack.innerHTML = "";
        mobileSlides = buildMobileSlides();
        desktopSlides = [];
      } else {
        desktopSlides = buildDesktopSlides();
        mobileSlides = [];
      }

      index = mod(index, slideCount);
      render();
      startAutoplay();
    }

    Array.prototype.forEach.call(prevBtns, function (btn) {
      btn.addEventListener("click", function () {
        goTo(index - 1);
      });
    });

    Array.prototype.forEach.call(nextBtns, function (btn) {
      btn.addEventListener("click", function () {
        goTo(index + 1);
      });
    });

    root.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") goTo(index - 1);
      if (e.key === "ArrowRight") goTo(index + 1);
    });

    root.addEventListener("mouseenter", stopAutoplay);
    root.addEventListener("mouseleave", startAutoplay);
    root.addEventListener("focusin", stopAutoplay);
    root.addEventListener("focusout", function (e) {
      if (!root.contains(e.relatedTarget)) startAutoplay();
    });

    if (carousel) {
      carousel.addEventListener(
        "touchstart",
        function (e) {
          var touch = e.touches[0];
          touchStartX = touch.clientX;
          touchStartY = touch.clientY;
        },
        { passive: true }
      );

      carousel.addEventListener(
        "touchend",
        function (e) {
          var touch = e.changedTouches[0];
          var deltaX = touch.clientX - touchStartX;
          var deltaY = touch.clientY - touchStartY;
          if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;
          if (deltaX < 0) goTo(index + 1);
          else goTo(index - 1);
        },
        { passive: true }
      );
    }

    applyLayoutMode();

    if (typeof MOBILE_MQ.addEventListener === "function") {
      MOBILE_MQ.addEventListener("change", applyLayoutMode);
    } else if (typeof MOBILE_MQ.addListener === "function") {
      MOBILE_MQ.addListener(applyLayoutMode);
    }
  }

  function boot() {
    var roots = document.querySelectorAll("[data-obs-loop]");
    Array.prototype.forEach.call(roots, initLoop);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();
